import { loginRequest } from "../../authConfig";
import { useMsal } from "@azure/msal-react";
import * as React from 'react';
import Button from '@mui/material/Button';

function LoginButton() {
    const { instance } = useMsal();

    const handleLogin = () => {
        async function msalLogin() {
            await instance.loginRedirect(loginRequest());
        }
        msalLogin()
    };
    
    return (
        <>
            <Button variant="contained" size="medium" sx={{marginTop: '20px'}} onClick={handleLogin}>
            Login
            </Button>
        </>
    );
}

export default LoginButton;